"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamFormationService = void 0;
var OpenAPI_1 = require("../core/OpenAPI");
var request_1 = require("../core/request");
var TeamFormationService = /** @class */ (function () {
    function TeamFormationService() {
    }
    /**
     * Initiate Team Formation
     * [Obsolete - DO NOT USE - Use v2 endpoint] Start a job to form teams
     * @param requestBody
     * @returns TeamFormationJobId Successful Response
     * @throws ApiError
     */
    TeamFormationService.initiateTeamFormation = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/team-formations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Initiate Team Formation V2
     * Start a job to form teams
     * @param requestBody
     * @returns any Success
     * @returns TeamFormationJobId Successful Response
     * @throws ApiError
     */
    TeamFormationService.initiateTeamFormationV2 = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/team-formations/v2-server',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Initiate Team Formation V3
     * Start a job to form teams via a Lambda
     * @param requestBody
     * @returns TeamFormationJobId Successful Response
     * @throws ApiError
     */
    TeamFormationService.initiateTeamFormationV3 = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/team-formations/v2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get Team Formation Result
     * Get the state of a team formation job
     * @param jid The job id returned by the team formation endpoint
     * @param next
     * @param limit
     * @returns TeamFormationJobResponse Success
     * @throws ApiError
     */
    TeamFormationService.getTeamFormationResult = function (jid, next, limit) {
        if (limit === void 0) { limit = 20; }
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/team-formations/{jid}',
            path: {
                'jid': jid,
            },
            query: {
                'next': next,
                'limit': limit,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Cancel Team Formation Job
     * Cancels the team formation process with job id jid
     * @param jid The job id returned by the team formation endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    TeamFormationService.cancelTeamFormationJob = function (jid) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'DELETE',
            url: '/team-formations/{jid}',
            path: {
                'jid': jid,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Initiate Team Formation Agent
     * Start a job to form teams, used by API key authenticated interactions
     * @param requestBody
     * @returns any Success
     * @returns TeamFormationJobId Successful Response
     * @throws ApiError
     */
    TeamFormationService.initiateTeamFormationAgent = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/team-formations/agent',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get Team Formation Result Agent
     * Get the state of a team formation job,
     * used by API key authenticated interactions
     * @param jid The job id returned by the team formation endpoint
     * @param next
     * @param limit
     * @returns TeamFormationJobResponse Success
     * @throws ApiError
     */
    TeamFormationService.getTeamFormationResultAgent = function (jid, next, limit) {
        if (limit === void 0) { limit = 20; }
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/team-formations/agent/{jid}',
            path: {
                'jid': jid,
            },
            query: {
                'next': next,
                'limit': limit,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Cancel Team Formation Job Agent
     * Cancels the team formation process with job id jid,
     * used by API key authenticated interactions
     * @param jid The job id returned by the team formation endpoint
     * @returns any Successful Response
     * @throws ApiError
     */
    TeamFormationService.cancelTeamFormationJobAgent = function (jid) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'DELETE',
            url: '/team-formations/agent/{jid}',
            path: {
                'jid': jid,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    return TeamFormationService;
}());
exports.TeamFormationService = TeamFormationService;
//# sourceMappingURL=TeamFormationService.js.map